import { useSegmentV1ControllerGetDefects } from 'generated/apiComponents';
import { useSession } from 'technical/auth/client';

export const useGetQuarantineDefectsData = (segmentId: string) => {
  const { data: session } = useSession();

  const { data, error, isLoading } = useSegmentV1ControllerGetDefects(
    {
      pathParams: { id: segmentId },
    },
    {
      enabled: !!session?.user.projectId,
    },
  );

  return {
    data,
    isLoading,
    error,
  };
};
